import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let person_referral_types = [
      { id: 'Patient', type: 'Search', text: 'Patient' },
      {
        id: 'Professional',
        type: 'Search',
        text: 'Professional',
      },
    ]
    return data.concat(person_referral_types)
  }, [data])
}
